import { pick } from 'lodash'

const typeMap = {
  1: '電話予約',
  2: 'ネット予約',
  3: 'ウォークイン',
  4: '電話自動受付予約（IVR）',
  5: 'POS＋',
  6: '台帳ネット予約',
  7: 'テイクアウト予約',
  8: 'レスラク',
  10: 'ブロック',
}

export default typeMap

export const getTypeMapBySyncType = syncType => {
  if (syncType === 7) return pick(typeMap, [4])
  if (syncType === 8) return pick(typeMap, [5])
  if (syncType === 15) return pick(typeMap, [6])
  return pick(typeMap, [1, 2, 3])
}

export const takeoutType = pick(typeMap, [7])

export const resrakuType = pick(typeMap, [8])

export function isWalkin(type) {
  return [3, 5, 9].includes(type)
}

export function isTakeout(type) {
  return type === 7
}

export function isResraku(type) {
  return type === 8
}

export function isBlock(type) {
  return type === 10
}
